import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @description Setup YCP delivery service integration parameters
 * @tags Integrations
 */
export const SetupYCPDeliveryContentType = '' as const;
export type SetupYCPDeliveryRequest = void;
export type SetupYCPDeliveryResponses = LinkCommonErrorResponses & {};
export type SetupYCPDeliveryResponseSuccess = undefined;
export type SetupYCPDeliverySearchParams = undefined;
export type SetupYCPDeliveryPathParameters = undefined;
export const SetupYCPDeliveryUrl = '/integrations/delivery/ycp/setup' as const;
export const SetupYCPDeliveryMethod = 'POST' as const;
export const getSetupYCPDeliveryUrl = (_params?: SetupYCPDeliveryPathParameters) => SetupYCPDeliveryUrl;
